function BypassProvider() {
    return new Set([
        'required',
        'analytics',
        'functional'
    ]);
}

export { BypassProvider };
//# sourceMappingURL=bypass-provider.js.map
